(function () {
    'use strict';
    jcu_js_v1.vars.chatTimeOut = null;
    jcu_js_v1.fn.chatButtonClicked = function (event) {
        var btn = event.currentTarget;
        btn.classList.toggle('collapsed');
        document.querySelector('.jcu-v1__live-chat__wrapper').classList.toggle('hidden');
        if(btn.classList.contains('collapsed')){
            jcu_js_v1.fn.pollChatAgent();
        }else{
            clearTimeout(jcu_js_v1.vars.chatTimeOut);
           // console.log("clearTimeout");
        }
    };


    jcu_js_v1.fn.initChatButton = function () {
        var chat__btn = document.querySelector('.jcu-v1__live-chat__btn');
        if (chat__btn !== null) {
            chat__btn.addEventListener('click', jcu_js_v1.fn.chatButtonClicked, false);
        }
    }

    jcu_js_v1.fn.pollChatAgent = function () {
        var liveChatButton = document.querySelector('.jcu-v1__live-chat__btn');
        
        var chatAgentURL = liveChatButton.dataset.chatagenturl;
        if(typeof(chatAgentURL) !== "undefined" ){
            //if the live chat is currently open, stop the polling of the availability
            // otherwise the chat button disappears and the user cant close the window

            var isChatCurrentlyOpen = liveChatButton.classList.contains('collapsed') === false;
        //    console.log("pollChatAgent",isChatCurrentlyOpen);
            if(isChatCurrentlyOpen !== true){
                $.ajax({
                    url: chatAgentURL, success: function (result) {
                        result = JSON.parse(result);

                        if (result["out_of_hours"] === undefined) {
                            if (result.stats !== undefined && result.stats.availableSessionCount > 0) {
                            // console.log('availible sessions: ' + result.stats.availableSessionCount);
                                if (liveChatButton !== null) {
                                    liveChatButton.classList.remove('hidden');
                                }
                                clearTimeout(jcu_js_v1.fn.pollChatAgent)
                            } else if (result.stats !== undefined && result.stats.availableSessionCount == 0) {
                            // console.log('no sessions');
                                if (liveChatButton !== null) {
                                    liveChatButton.classList.add('hidden');
                                }
                            } 
                        } else if (result["out_of_hours"]) {
                        // console.log('out of hours');
                            if (liveChatButton !== null) {
                                liveChatButton.classList.add('hidden');
                            }
                        }
                    }
                });
                jcu_js_v1.vars.chatTimeOut = setTimeout(jcu_js_v1.fn.pollChatAgent, 8000);
            }

        }
    }

    jcu_js_v1.fn.initPollChatAgent = function () {
        var chat__btn = document.querySelector('.jcu-v1__live-chat__btn');
        //if there is a chat button on the page start the polling to the chat agent
       // console.log("-----", chat__btn);
        if (chat__btn !== null) {
            jcu_js_v1.fn.pollChatAgent();

        }
    }
    jcu_js_v1.fn.initChatButton();
    jcu_js_v1.fn.initPollChatAgent();



}());
